import { EVENT } from "@/constants/event";
import type { OperationType } from "@/types/inspirationWords";
import { useEffect } from "react";

/**
 * Hook: 监听详情页事件
 *
 * 职责：
 * - 接收详情页触发的灵感词记录事件
 * - 过滤出属于当前 pageScope 的事件
 * - 调用 recordOperation 记录操作
 *
 * @param recordOperation - 记录操作的回调函数
 * @param enabled - 是否启用（默认 true）。当为 false 时，不监听事件
 */
export function useDetailPageEventListener(
  recordOperation: (fileId: string, type: OperationType) => void,
  enabled = true
) {
  useEffect(() => {
    // AB 未开启时跳过所有监听逻辑
    if (!enabled) return;

    const handleRecord = (event: CustomEvent) => {
      const { fileId, type, pageScope } = event.detail;
      if (pageScope === "pin_recommend_word") {
        recordOperation(fileId, type);
      }
    };

    window.addEventListener(
      EVENT.INSPIRATION_WORDS_RECORD,
      handleRecord as EventListener
    );

    return () => {
      window.removeEventListener(
        EVENT.INSPIRATION_WORDS_RECORD,
        handleRecord as EventListener
      );
    };
  }, [recordOperation, enabled]);
}
